// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from "./App.vue"
//import VueRouter from 'vue-router'
import router from './router/'
import iView from "iview"
//import "./theme/index.less"
//import 'iview/dist/styles/iview.css'
//import ElementUI from 'element-ui'
//import 'element-ui/lib/theme-chalk/index.css';
import {install} from "./fui"
//import Plugin from './plugin/'
//import components from './components/'
//import enResource from './resource/sysResource.en.js'
//import zhResource from './resource/sysResource.zh.js'


Vue.config.productionTip = false;
//Vue.prototype.$ = window.$;

$.userState = {
  isLogin: false,
  menuList: null,
  name: null,
  no: null
};
/*
window.fuiNeedInitHeight=0
window.fuiContentWidth = window.innerWidth
window.addEventListener("resize", function(){
  if (window.fuiSetHeightTime) clearTimeout(window.fuiSetHeightTime)
  window.fuiSetHeightTime = setTimeout(() => {
    const cnt = document.querySelector("#fuiContent")
    if (cnt) window.fuiContentWidth = cnt.offsetWidth
    this.fuiInitListPanelHeight()
  }, 300)
   //const fc = document.querySelector("#fuiContent")
   //if (fc) window.fuiContentHeight= fc.offsetHeight
})

window.fuiInitListPanelHeight=function(el){
  if (!el) el = document.querySelector("#listPanel")
  const pager = document.querySelector("#pagerPanel")
  if (pager)  el.style.top = (pager.offsetTop + pager.offsetHeight) + "px"
}

window.$fuiLoader = document.querySelector("#loader")
window.$fuiDownloader = document.querySelector("#fuiDownload")

window.fuiTitle = "System"
*/
//Vue.prototype.$loader=loader
//console.log(loader)

//console.log(install)
//$.enResource = enResource
//$.zhResource = zhResource

Vue.prototype.$lan="zh"
//const fui = ()=>import("http://www.padmac-china.com/its/frame/scripts/fgdui.min.js")
//console.log(fui())
//Vue.use(ElementUI)
Vue.use (install)
Vue.use (iView)
/*
Vue.use (fui.plugin.resource)
Vue.use (fui.plugin.loader)
Vue.use (fui.plugin.prop)
Vue.use (fui.plugin.position)
Vue.use (fui.plugin.other)

Vue.component("fuiTop", fui.components.fuiTop)
Vue.component("fuiContent", fui.components.fuiContent)
Vue.component("dateInput", fui.components.dateInput)
Vue.component("propPanel", fui.components.propPanel)
Vue.component("exportFile", fui.components.exportFile)
Vue.component("pagerPanel", fui.components.pagerPanel)
Vue.component("paramPanel", fui.components.paramPanel)
Vue.component("listPanel", fui.components.listPanel)
*/


//Vue.use(Plugin)
/*
Object.keys(Plugin).forEach((key) => {
  Vue.use(Plugin[key])
})


Object.keys(components).forEach((key) => {
  Vue.component(key, components[key])
})
*/
/* eslint-disable no-new */
new Vue({
  created(){
    this.$loader = loader
  },
  render: h=>h(App),
  router,
}).$mount("#app");
